import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-339023df")

_pushScopeId("data-v-339023df")
const _hoisted_1 = { class: "info-title-bottom" }
const _hoisted_2 = { class: "info-light-title" }
const _hoisted_3 = { class: "name-slot" }
const _hoisted_4 = { style: {"margin-right":"8px"} }
const _hoisted_5 = { class: "contact-detail-slot" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_tip = _resolveComponent("tip")
  const _component_list = _resolveComponent("list")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("label", _hoisted_2, _toDisplayString(_ctx.$wordList.RDeviceResidents), 1)
    ]),
    _createVNode(_component_list, {
      headers: _ctx.headers,
      update: _ctx.updateToList,
      "list-data": _ctx.residentsList,
      "request-data": false,
      showCheck: false,
      action: false
    }, {
      NameSlot: _withId((data) => [
        _createVNode("div", _hoisted_3, [
          _createVNode("label", _hoisted_4, _toDisplayString(data.scope.Name), 1),
          (data.scope.Role=== _ctx.access.comEndRole)
            ? (_openBlock(), _createBlock(_component_tip, { key: 0 }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextMasterAccount), 1)
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_tip, {
                key: 1,
                color: "#676767"
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextMemberAccount), 1)
                ]),
                _: 1
              })),
          _createVNode("img", {
            class: "name-img",
            src: _ctx.MasterStatusIcons[data.scope.Mark],
            ref: _ctx.setAllImg
          }, null, 8, ["src"])
        ])
      ]),
      ContactDetailSlot: _withId((data) => [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", null, [
            _createVNode("img", {
              class: "img-size vertical-align-middle",
              src: _ctx.ContactDetailIcons.phone,
              ref: _ctx.setAllImg
            }, null, 8, ["src"]),
            _createTextVNode(_toDisplayString(_ctx.filterEmptyCellValue(data.scope.MobileNumber)), 1)
          ]),
          _createVNode("div", null, [
            _createVNode("img", {
              class: "img-size vertical-align-middle",
              src: _ctx.ContactDetailIcons.email,
              ref: _ctx.setAllImg
            }, null, 8, ["src"]),
            _createTextVNode(_toDisplayString(_ctx.filterEmptyCellValue(data.scope.Email)), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["headers", "update", "list-data"])
  ]))
})